fragment MediaFragment on MediaInterface {
    id
    filename
    extension
    mime_type
    media_width
    media_height
    alt_text
    title
    caption
    path
    url
    created_at
    updated_at
}